// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewWorkflowFormModel () {
        return ReviewWorkflowFormModel;
    },
    get ReviewWorkflowModel () {
        return ReviewWorkflowModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _review = require("./review");
const BaseReviewWorkflowFormModel = _zod.z.object({
    id: _zod.z.instanceof(_bson.ObjectId).optional(),
    form_id: _zod.z.instanceof(_bson.ObjectId),
    visible: _zod.z.boolean(),
    redacted: _zod.z.boolean(),
    days_to_complete_authors: _zod.z.number(),
    days_to_complete_signers: _zod.z.number(),
    days_to_complete: _zod.z.number().optional(),
    deleted_at: _zod.z.date().optional()
});
const InternalReviewWorkflowFormModel = BaseReviewWorkflowFormModel.extend({
    authors: _zod.z.array(_review.ReviewAuthorParticipant).optional(),
    signers: _zod.z.array(_review.ReviewParticipant).optional(),
    external: _zod.z.literal(false),
    author: _review.ReviewAuthorParticipant.nullable().optional(),
    signer: _review.ReviewParticipant.nullable().optional(),
    basic: _zod.z.boolean().optional(),
    easy_add: _zod.z.boolean().optional()
});
const ExternalReviewWorkflowFormModel = BaseReviewWorkflowFormModel.extend({
    authors: _zod.z.array(_review.ExternalReviewAuthor).optional(),
    external: _zod.z.literal(true),
    author: _review.ExternalReviewAuthor.nullable().optional()
});
const ReviewWorkflowFormModel = _zod.z.union([
    ExternalReviewWorkflowFormModel,
    InternalReviewWorkflowFormModel
]);
const ReviewWorkflowModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    alignment: _zod.z.object({}).optional(),
    ancestors: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    assignee: _zod.z.instanceof(_bson.ObjectId).optional(),
    categories: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    color: _zod.z.instanceof(_bson.ObjectId).optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    deleted: _zod.z.boolean().optional(),
    deleted_at: _zod.z.date().optional(),
    description: _zod.z.string().optional(),
    end_date: _zod.z.date().optional(),
    forms: _zod.z.array(ReviewWorkflowFormModel),
    initial_value: _zod.z.number().optional(),
    insensitive_name: _zod.z.string().optional(),
    is_top: _zod.z.boolean().optional(),
    last_update: _zod.z.date().optional(),
    name: _zod.z.string(),
    owner: _zod.z.instanceof(_bson.ObjectId).optional(),
    seen_by: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    sharers: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    start_date: _zod.z.date().optional(),
    status: _zod.z.enum([
        "active",
        "done"
    ]).optional(),
    target: _zod.z.number().optional(),
    transparency: _zod.z.enum([
        "public",
        "private"
    ]).optional(),
    units: _zod.z.string().optional(),
    value: _zod.z.number().optional()
});
